import "../../design/toast.css";
import { useEffect } from "react";

export default function Toast({ message, type, onClose }) {

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`toast toast-${type}`}>
            <div>
                {message}&nbsp;&nbsp;&nbsp;
            </div>
            <div onClick={onClose}>{`X`}</div>
        </div>
    );
}